export const ENVIRONMENT: 'development' | 'production' | 'demo' = 'production'
export const REVISION: string = '75f9c93418c8ac8ae4950a3f8299086ed3099a4e'



// WEBPACK FOOTER //
// ./src/config/environment.ts